import { Typography } from "antd";
import styled from "styled-components";

import { FONT_VARIANTS, FONT_WEIGHTS } from "../Typography.constants";
import { TTextStyleProps } from "./Text.types";

export const TextStyled = styled(Typography.Text)<TTextStyleProps>`
    font-weight: ${props => FONT_WEIGHTS[props.$weight]};
    ${props => FONT_VARIANTS[props.$variant]};
`;
